"use client";
import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import "../App.css";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.message.trim()) {
      alert("Please fill in your name and message.");
      return;
    }

    const whatsappMessage = `*New Contact Form Submission*

*Name:* ${formData.name}
*Email:* ${formData.email || "Not provided"}

*Message:*
${formData.message}`;

    const phoneNumber = "919924382499";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappUrl, "_blank");

    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="page-wrapper light-section min-vh-100">
      {/* Hero Banner Section */}
      <div className="page-banner position-relative">
        <div className="glowing-orb primary top-50 start-50 translate-middle" style={{ width: '400px', height: '400px', opacity: 0.5 }}></div>
        <div className="container position-relative z-1">
          <h1 className="page-banner-title text-white">Contact Us</h1>
          <div className="page-banner-breadcrumb text-light opacity-75">
            <a href="/" className="text-light">Home</a> <span>/</span> Contact Us
          </div>
        </div>
      </div>

      <div className="container section-padding position-relative">
        <div className="glowing-orb accent bottom-0 end-0" style={{ width: '300px', height: '300px' }}></div>
        <div className="row position-relative z-1">
          {/* Contact Info */}
          <div className="col-lg-5 mb-2 mb-lg-0">
            <div className="px-4 px-md-5 rounded-4 border-0 h-100 contact-card d-flex flex-column justify-content-center">
              <span className="section-pill mb-3 align-self-start ">Get in Touch</span>
              <h3 className="section-heading text-dark mb-3 mb-md-4">Contact <span className="text-primary fst-italic">Details</span></h3>
              <p className="text-muted-dark mb-4 mb-md-4">
                Have questions about our collection or need assistance? Reach out to us. We are here to help you build your dream space.
              </p>

              <div className="d-flex align-items-start gap-4 mb-4">
                <div className="text-primary fs-3 mt-1">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">Address</h6>
                  <p className="text-muted-dark small mb-0">
                    <a href="https://share.google/wGLZ3vJLBz6zjMhCd" target="_blank" rel="noopener noreferrer" className="text-muted-dark text-decoration-none">
                      Block No.221, New Ring Road,<br />
                      Saniya Kosmada Chokdi, Kosmada - 395006.
                    </a>
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-4 mb-4">
                <div className="text-primary fs-3 mt-1">
                  <FaPhoneAlt />
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">Phone</h6>
                  <p className="text-muted-dark small mb-0">
                    <a href="tel:+917202057575" className="text-muted-dark text-decoration-none">+91 72020 57575</a> (Customer Care)<br />
                    <a href="tel:+919624882499" className="text-muted-dark text-decoration-none">+91 96248 82499</a> (Vikram Sakariya)<br />
                    <a href="tel:+919924382499" className="text-muted-dark text-decoration-none">+91 99243 82499</a> (Rakshit Sakariya)
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-4 mb-4">
                <div className="text-primary fs-3 mt-1">
                  <FaWhatsapp />
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">WhatsApp Inquiry</h6>
                  <p className="text-muted-dark small mb-0">
                    <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="text-muted-dark text-decoration-none fw-bold">+91 99243 82499</a> (Rakshit Sakariya)<br />
                    <a href="https://chat.whatsapp.com/CciDF9dx73pD3eyBUtrWnV" target="_blank" rel="noopener noreferrer" className="text-muted-dark">Join WhatsApp Community</a>
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-4">
                <div className="text-primary fs-3 mt-1">
                  <FaEnvelope />
                </div>
                <div>
                  <h6 className="fw-bold text-dark mb-1">Email</h6>
                  <p className="text-muted-dark small mb-0">
                    <a href="mailto:kamdhenusteelindustries99@gmail.com" className="text-muted-dark text-decoration-none">kamdhenusteelindustries99@gmail.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Divider */}
          <div className="col-12 d-lg-none px-4 px-md-5 py-4 my-2">
            <hr className="my-2 mx-2" style={{ borderTop: '2px solid rgba(0, 0, 0, 0.5)' }} />
          </div>

          {/* Contact Form */}
          <div className="col-lg-7">
            <div className="px-4 px-md-5 py-0 py-lg-5 rounded-4 border-0 h-100 contact-card">
              <h3 className="section-heading text-dark mb-3 mb-md-4">Send us a <span className="text-primary fst-italic">Message</span></h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label text-muted-dark small fw-bold">Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control form-control-lg bg-transparent text-dark border border-secondary border-opacity-25"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label text-muted-dark small fw-bold">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control form-control-lg bg-transparent text-dark border border-secondary border-opacity-25"
                    placeholder="Enter your email address"
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label text-muted-dark small fw-bold">Your Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control form-control-lg bg-transparent text-dark border border-secondary border-opacity-25"
                    rows="5"
                    placeholder="Write your furniture inquiry or requirements here..."
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-lg w-100 rounded-pill mt-2 hover-lift">
                  <FaWhatsapp className="me-2" /> Send via WhatsApp
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="mt-5 mt-lg-5 position-relative z-1 px-4 px-md-5 px-lg-0">
          <div className="shadow white-card p-2 p-md-3 rounded-4 border-0 d-flex align-center">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.7869905879325!2d72.91657370516022!3d21.200619166117022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04fe1ebd2c169%3A0x36c917ead0a54ece!2sKamdhenu%20Steel%20Industries!5e0!3m2!1sen!2sin!4v1788588430646!5m2!1sen!2sin"
              width="100%"
              className="contact-map-iframe"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              title="Google Maps"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

